
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 96 96","xmlns":"http://www.w3.org/2000/svg","fill":"none"}, attrs),
              ...rest,
            },
            children.concat([_c('rect',{attrs:{"x":"9.25","y":"14.25","width":"77.5","height":"52.5","rx":"6.75","fill":"currentColor","fill-opacity":".07","stroke":"currentColor","stroke-width":"2.5"}}),_c('rect',{attrs:{"x":"17","y":"22","width":"62","height":"37","rx":"3","fill":"currentColor","fill-opacity":".16"}}),_c('path',{attrs:{"d":"M48 67v9","stroke":"currentColor","stroke-width":"2.5"}}),_c('rect',{attrs:{"x":"31","y":"76","width":"34","height":"6","rx":"3","fill":"currentColor","fill-opacity":".45"}})])
          )
        }
      }
    